import React from "react";
import PopupModal from "../../../UI/Popup";
import { TJobData } from "../../../../store/candidate/types";
import {
  getJobCentreNameByVacancy,
  getJobTitleNameForCandidate,
} from "../../../../services/candidateJobsService";
import { formatTimeframes } from "../../../Vacancy/timeframeApiHelper";
import CircleTickFill from "../../../UI/Icons/CircleTickFill";

interface ConfirmApplyJobModalProps {
  showApplyJobModal: boolean;
  setShowApplyJobModal: React.Dispatch<React.SetStateAction<boolean>>;
  onClickClose?: () => void;
  vacancyData: TJobData;
  handleApplyForJob?: (vacancyData: TJobData) => void;
  onRefresh?: () => void;
  loadDayJobs?: () => void;
  setShowViewModal?: (show: boolean) => void;
  handleView?: (id: number) => void;
  centreId?: number;
  showSingleDayView?: (show: boolean) => void;
}

const ConfirmApplyJobModal: React.FC<ConfirmApplyJobModalProps> = ({
  showApplyJobModal,
  handleApplyForJob,
  onClickClose,
  setShowApplyJobModal,
  vacancyData,
  onRefresh,
  loadDayJobs,
  setShowViewModal,
  handleView,
  centreId,
  showSingleDayView
}) => {
  const handleClose = () => {
    setShowApplyJobModal(false);
    if (onClickClose) {
      onClickClose();
      
    }
    // showSingleDayView && showSingleDayView(false);
    // setShowViewModal?.(false);
    if (centreId !== undefined) {
      handleView?.(centreId);
    }
    onRefresh && onRefresh();      
    // loadDayJobs && loadDayJobs();
  };

  return (
    <PopupModal
      visible={showApplyJobModal}
      showCloseBtn={true}
      onClickClose={handleClose}
      customWidth={650}
    >
      <div className="gap-20 fs-22">
        <CircleTickFill />
        Your application has been sent
      </div>
      <div className="gap-20 fs-13">
        Thank you for applying for this job:{" "}
        {getJobTitleNameForCandidate(vacancyData)} at{" "}
        {getJobCentreNameByVacancy(vacancyData)}, {vacancyData?.centre?.address}{" "}
        {vacancyData?.timeframes &&
          formatTimeframes(vacancyData?.timeframes)?.map(
            (formatedTimeData, index) => (
              <span
                key={index}
                className={`fs-13 ${
                  formatedTimeData.alert ? "text-alert fw-700" : "fw-400"
                }`}
              >
                {formatedTimeData.label}
              </span>
            )
          )}
      </div>
      <div className="gap-20 fs-13">
        The centre is currently reviewing all applications and will confirm the
        successful candidate ASAP.{" "}
      </div>
      <div className="gap-20 fs-13">
        This job listing will be moved to your Pending tab.
      </div>

      {/* Add your modal content here */}
    </PopupModal>
  );
};

export default ConfirmApplyJobModal;
